import React from "react";
import FeatureToggleBulkDeleteUpload from "../../../components/FeatureToggleUpload/FeatureToggleBulkDeleteUpload";

const FeatureToggleBulkDelete = () => {
  return <FeatureToggleBulkDeleteUpload />;
};

export default FeatureToggleBulkDelete;
